<template>
  <Loading :loading="loading" class="pageContent container">
    <div class="brand my-3" v-if="brand">
      <div class="row">
        <div class="col-auto col-md-4">
          <router-link v-if="$route.params.backRoute" :to="{path:$route.params.backRoute}" class="btn btn-outline-primary">
            Back to {{$route.params.backName}}
          </router-link>
        </div>
        <div class="col-auto productTitleDiv">
          <h2>{{brand.title}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <img v-if="brand.images && brand.images[0]" :src="imageUrl(brand.images[0].sizes)" class="max-size">
        </div>
        <div class="col-12 col-md-8">
          <!-- Generic for if there is no description -->
          <p  v-if="brand.description==''">This brand is available to Gold &amp; Platinum Members only as it is a build/renovation brand and therefore restricted. If you are a Silver Member and building or renovating we highly recommend that you upgrade your membership to maximise the huge savings available as a Gold or Platinum Member</p>
          <!-- Generic for if there is a description -->
          <div v-else-if="restrictedBrands.includes(brand.brand)">
            <p>This brand’s product range is available exclusively to Gold and Platinum Members. To access this range, upgrade your Silver Membership to <router-link :to="{name:'accountGoldUpgrade'}">Gold</router-link>.</p>

          </div>
          <div v-else>
            <!-- <p>We offer the range of products from this brand even though they aren’t listed on our site.  Just visit their site, pick what you want (remember to get the product code/s) and use our 'Request a Price' page or use the button below.</p>-->
          <!-- TODO wording -->
            <p v-html="brand.description"></p>
            <!-- <p><i>{{brand.brand}}</i> products are available through Cherrytree, however the full range may not yet be loaded to our website.</p> -->
            <p>To see what is on our website:</p>
            <ol>
              <li>Type the brand name into the search bar on the top right of our home page and click to search</li>
              <li>Then use the filters on the left-hand side of the page to narrow your search down further</li>
            </ol>
			<p>If you have a product in mind, simply click on the suggested Brand Website link, view their product range, identify any applicable product code/s and descriptions, then use our 'Request a Price' page, or use the button below.</p>
            <!-- <p>We offer the range of products from this brand even though they aren’t all listed on our site. If you have a product in mind that you can’t find simply visit their site, pick what you want (remember to get the product code/s) and use our <strong>'Request a Price'</strong> page or use the button below.</p> -->
            <!-- If there is a description, show it -->
          </div>
          <div v-if=" !restrictedBrands.includes(brand.brand)">
            <a class="btn btn-green d-block d-md-inline-block my-3 mx-auto" v-if="brand.product_url && brand.product_url.length > 0"
              :href="brand.product_url"
              target="_blank">
              View Brand Website <ExternalLinkIcon fill="white" style="padding:2px"/>
            </a>
            <br class="d-none d-md-block">
            <router-link v-if="memberLevel!='public'" :to="{name:'get-a-price', query:{brand:brand.title}}" class="btn d-block d-md-inline-block btn-primary my-3 mx-auto">Request a Price</router-link>
            <router-link v-else :to="{ name: 'signup'}" class="btn d-block d-md-inline-block btn-primary my-3 mx-auto">Sign Up</router-link>
          </div>
        </div>
      </div>
      <vue-headful :title="brand.title + ' | Cherrytree'"/>
    </div>
    <div v-else class="col-6 text-center">
      Oops something went wrong, we can't find that brand. Please try again, or go to our
      <router-link :to="{name:'home'}">Home Page</router-link>
    </div>
  </Loading>
</template>

<script>
import { mapState } from "vuex";
import { fetchBrand, getRestrictedBrands } from "@/network/brandRequests";
import Loading from "@/components/loading/Loading";

import ExternalLinkIcon from '@/assets/img/external-link.svg';

import {imageUrl} from "@/utils";
import { makeProductObject } from "@/gaUtils"

export default {
  name: "Brands",
  components: {
    Loading,
    ExternalLinkIcon
  },
  data() {
    return {
      brandData: null,
      search: "",
      loading: false,
      source: ""
    };
  },
  created() {
    this.loadData();
    if (this.$route.params.source) {
      this.source = this.$route.params.source
    }
  },
  methods: {
    imageUrl,
    loadData() {
      this.loading = true;
      let brandId = this.$route.params.brand;

      fetchBrand(
        brandId,
        result => {
          this.brandData = result;
          this.loading = false;
          this.sendGA();
        },
        () => {
          //error
          this.loading = false;
        }
      );
    },
    sendGA() {
			this.$gtm.trackEvent({
				event: "productView",
				ecommerce: {
					detail: {
						actionField: {
							list: (this.source == "search") ? "Search" : "Brands"
						},
						products: [makeProductObject(this.brandData.product, false, "Brands")]
					}
				}
			})
		}
  },
  computed: {
    ...mapState({
      memberLevel: state => state.auth.memberLevel
    }),
    brand() {
      if (this.brandData) {
        return this.brandData.product;
      }
      return false;
    },
    restrictedBrands(){
      if(this.memberLevel == "silver" || this.memberLevel == "public" ){
        return getRestrictedBrands
      }
      else{
        return []
      }
    },
  },
  watch: {
    '$route' (to, from) {
        //on route change re run: onCreated
        this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>

.max-size{
  max-width: 250px;
  max-height: 250px;
}


@include media-breakpoint-down(sm){
  .productTitleDiv {
    display: block;
    width: 100%;
    margin-top: 30px;
  }
}

</style>
